import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { __ } from 'i18n/index';
import NotificationIcon from 'react/notifications/NotificationIcon';
import { finishNotificationToast } from 'react/redux/actions/notifications';

export const TOAST_DURATION_MILLISECONDS = 6000;

// Achievement toasts, one at a time from the queue. Each shows for six
// seconds (or until closed), then the server records it as shown.
export default function ToastStack() {
	const dispatch = useDispatch();
	const toast = useSelector((state) => state.notifications.toastQueue[0] || null);
	const toastId = toast ? toast.id : null;

	useEffect(() => {
		if(toastId === null) {
			return undefined;
		}
		const timer = setTimeout(() => dispatch(finishNotificationToast(toastId)), TOAST_DURATION_MILLISECONDS);
		return () => clearTimeout(timer);
	}, [toastId]);

	if(!toast) {
		return null;
	}
	const data = toast.data || {};
	return (
		<div className='notification-toast' role='status' key={toast.id}>
			<span className='notification-toast__icon'>
				{data.image_url ? <img src={data.image_url} alt='' /> : <NotificationIcon name='trophy' size={24} />}
			</span>
			<span className='notification-toast__body'>
				<span className='notification-toast__kicker'>{__('Achievement unlocked')}</span>
				<b className='notification-toast__title'>{data.title}</b>
				<span>{data.description}</span>
				{toast.url && <a href={toast.url}>{__('View achievements')}</a>}
			</span>
			<button
				type='button'
				className='notification-toast__close'
				aria-label={__('Dismiss')}
				onClick={() => dispatch(finishNotificationToast(toast.id))}
			>
				<NotificationIcon name='close' size={16} />
			</button>
			<i className='notification-toast__timer' style={{ animationDuration: `${TOAST_DURATION_MILLISECONDS}ms` }} />
		</div>
	);
}
